import React from 'react';
import classNames from 'classnames';

import Loading from "../../shared/components/misc/Loading";
import RequirementItem from './RequirementItem';
import { segmentEventTracker } from "../../../utils/SegmentEventTracker";
import { TrackEventName } from "../../shared/constants/SegmentEvents";

const PTPRequirements = ({ ptp, loading, onSubmit, push }) => {
  if (loading) return <div className="ds-card"><Loading /></div>;

  function isButtonDisabled() {
    return ptp.are_any_requirements_rejected;
  }

  const containerClassName = () => {
    return classNames(
      'ds-card',
      {'-success': ptp.are_all_requirements_pending_or_verified},
    );
  }

  const subheadClassName = () => {
    return classNames(
      'subhead _noBottomMargin',
      {'-success': ptp.are_all_requirements_pending_or_verified},
    );
  }

  const submitButtonClassName = () => {
    return classNames(
      'ds-btn',
      '--full',
      {'_disabled': isButtonDisabled()},
    );
  }

  const ptpProgress = () => {
    if(ptp.incomplete_requirements_count === 0) {
      return <small className="byline _right -success">Completed</small>
    } else {
      return (
        <small className="byline _right">
          {Math.abs(ptp.incomplete_requirements_count - ptp.total_requirements)} of {ptp.total_requirements} completed
        </small>
      )
    }
  }

  const pushAction = (route, eventName) => {
    segmentEventTracker.trackEvent(eventName);
    push(route);
  };

  return (
    <div className={containerClassName()}>
      <section className="cardSection _withColumns _simple _noMinHeight _noBorder">
        <h2 className={subheadClassName()}>Your Personal Information</h2>
        {ptpProgress()}
      </section>

      <RequirementItem
        status={ptp['information_status']}
        header="Complete Your Personal info"
        onClick={ () => pushAction("/personal_trustpass/information/new",
          TrackEventName.COMPLETE_PERSONAL_INFO_CLICKED)
        }
        dataTest='complete-personal-info'
      />

      { !ptp.are_all_requirements_pending_or_verified &&
          <a onClick={onSubmit}
            className={submitButtonClassName()}
            disabled={isButtonDisabled()}
          >
            Submit For Verification
          </a>
      }
    </div>
  );
};

export default PTPRequirements;



// WEBPACK FOOTER //
// ./src/features/home/components/PTPRequirements.js